(function () {
  "use strict";

  var activeIntersectionObserver = null;

  function tearDown(section) {
    if (activeIntersectionObserver) {
      activeIntersectionObserver.disconnect();
      activeIntersectionObserver = null;
    }

    var old;
    old = section.querySelector(".infinite-scroll-sentinel");
    if (old) old.remove();
    old = section.querySelector(".infinite-scroll-spinner");
    if (old) old.remove();
    old = section.querySelector(".infinite-scroll-load-more");
    if (old) old.remove();
  }

  var AUTO_LOAD_LIMIT = 3;

  function setupInfiniteScroll(section) {
    var productList = section.querySelector("product-list.product-list");
    var paginationEl = section.querySelector(".pagination");
    if (!productList || !paginationEl) return;

    paginationEl.hidden = true;

    var autoLoadCount = 0;

    var sentinel = document.createElement("div");
    sentinel.className = "infinite-scroll-sentinel";
    productList.insertAdjacentElement("afterend", sentinel);

    var spinner = document.createElement("div");
    spinner.className = "infinite-scroll-spinner";
    spinner.hidden = true;
    sentinel.insertAdjacentElement("afterend", spinner);

    var loadMoreBtn = document.createElement("button");
    loadMoreBtn.type = "button";
    loadMoreBtn.className = "infinite-scroll-load-more button button--outline";
    loadMoreBtn.textContent = "Load More";
    loadMoreBtn.hidden = true;
    spinner.insertAdjacentElement("afterend", loadMoreBtn);

    var loading = false;

    function getNextUrl() {
      var link = paginationEl.querySelector('a[rel="next"]');
      return link ? link.href : null;
    }

    function switchToManual() {
      if (activeIntersectionObserver) {
        activeIntersectionObserver.disconnect();
        activeIntersectionObserver = null;
      }
      sentinel.remove();
      if (getNextUrl()) {
        loadMoreBtn.hidden = false;
      }
    }

    function loadNextPage(triggeredByButton) {
      var url = getNextUrl();
      if (!url || loading) return;

      loading = true;
      spinner.hidden = false;
      if (triggeredByButton) {
        loadMoreBtn.hidden = true;
      }

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error("HTTP " + response.status);
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          var newProductList = doc.querySelector("product-list.product-list");
          if (newProductList) {
            var fragment = document.createDocumentFragment();
            Array.from(newProductList.children).forEach(function (child) {
              child.removeAttribute("reveal-on-scroll");
              fragment.appendChild(child);
            });
            productList.appendChild(fragment);
          }

          var newPagination = doc.querySelector(".pagination");
          paginationEl.innerHTML = newPagination ? newPagination.innerHTML : "";

          if (typeof ReloadSmartWishlist === "function") {
            ReloadSmartWishlist();
          }

          if (!getNextUrl()) {
            if (activeIntersectionObserver) {
              activeIntersectionObserver.disconnect();
              activeIntersectionObserver = null;
            }
            sentinel.remove();
            loadMoreBtn.hidden = true;
          } else if (triggeredByButton) {
            loadMoreBtn.hidden = false;
          } else {
            autoLoadCount++;
            if (autoLoadCount >= AUTO_LOAD_LIMIT) {
              switchToManual();
            }
          }
        })
        .catch(function (err) {
          console.error("[InfiniteScroll] Failed to load page:", err);

          if (triggeredByButton) {
            loadMoreBtn.hidden = false;
          }
        })
        .finally(function () {
          loading = false;
          spinner.hidden = true;
        });
    }

    loadMoreBtn.addEventListener("click", function () {
      loadNextPage(true);
    });

    activeIntersectionObserver = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting && !loading) {
          loadNextPage(false);
        }
      },
      { rootMargin: "300px" },
    );

    activeIntersectionObserver.observe(sentinel);

    if (typeof ReloadSmartWishlist === "function") {
      ReloadSmartWishlist();
    }
  }

  function init() {
    var section = document.querySelector(".shopify-section--main-collection");
    if (!section) return;

    tearDown(section);
    setupInfiniteScroll(section);

    var mutationObserver = new MutationObserver(function () {
      tearDown(section);
      setupInfiniteScroll(section);
    });
    mutationObserver.observe(section, { childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

(function () {
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".filter-toggle-btn");
    if (!btn) return;
    var sectionEl = btn.closest("[id^='shopify-section-']");
    if (!sectionEl) return;
    var hidden = sectionEl.classList.toggle("filters-hidden");
    btn.setAttribute("aria-expanded", hidden ? "false" : "true");
    var label = btn.querySelector(".filter-toggle-label");
    if (label) label.textContent = hidden ? "Show Filters" : "Hide Filters";
  });

  function syncBtn(sectionEl) {
    var btn = sectionEl.querySelector(".filter-toggle-btn");
    if (!btn) return;
    var hidden = sectionEl.classList.contains("filters-hidden");
    btn.setAttribute("aria-expanded", hidden ? "false" : "true");
    var label = btn.querySelector(".filter-toggle-label");
    if (label) label.textContent = hidden ? "Show Filters" : "Hide Filters";
  }

  function init() {
    var sectionEl = document.querySelector(".shopify-section--main-collection");
    if (!sectionEl) return;
    new MutationObserver(function () {
      syncBtn(sectionEl);
    }).observe(sectionEl, { childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

(function () {
  "use strict";

  var drawer, drawerTitle, drawerSizes, backdrop;
  var drawerOpen = false;
  var quickAddToastEl = null;
  var quickAddToastTimer = null;

  function getQuickAddToast() {
    if (quickAddToastEl) return quickAddToastEl;

    quickAddToastEl = document.createElement("div");
    quickAddToastEl.className = "quick-add-toast";
    quickAddToastEl.setAttribute("role", "status");
    quickAddToastEl.setAttribute("aria-live", "polite");
    document.body.appendChild(quickAddToastEl);

    return quickAddToastEl;
  }

  function showQuickAddToast(message, isError) {
    var toast = getQuickAddToast();
    toast.textContent = message || "Could not add to cart";
    toast.classList.toggle("is-error", !!isError);
    toast.classList.add("is-visible");

    if (quickAddToastTimer) {
      clearTimeout(quickAddToastTimer);
    }

    quickAddToastTimer = setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 2600);
  }

  function setup() {
    backdrop = document.createElement("div");
    backdrop.className = "quick-add-drawer-backdrop";
    document.body.appendChild(backdrop);

    drawer = document.createElement("div");
    drawer.className = "quick-add-drawer";
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-modal", "true");
    drawer.setAttribute("aria-hidden", "true");
    drawer.innerHTML =
      '<div class="quick-add-drawer__header">' +
      '<p class="quick-add-drawer__title"></p>' +
      '<button type="button" class="quick-add-drawer__close js-qa-close" aria-label="Close">&times;</button>' +
      "</div>" +
      '<div class="quick-add-drawer__sizes"></div>';
    document.body.appendChild(drawer);

    drawerTitle = drawer.querySelector(".quick-add-drawer__title");
    drawerSizes = drawer.querySelector(".quick-add-drawer__sizes");
  }

  function addToCart(variantId, btn) {
    if (!variantId || !btn) return;
    if (btn.classList.contains("is-loading")) return;
    btn.classList.add("is-loading");
    btn.disabled = true;
    btn.setAttribute("aria-busy", "true");

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }),
    );

    var formData = new FormData();
    formData.set("id", String(variantId));
    formData.set("quantity", "1");
    formData.set("on_success", "force_open_drawer");
    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", Shopify.routes.root + "variants/" + variantId);

    fetch(Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: formData,
    })
      .then(function (res) {
        return res.json().then(function (json) {
          return { ok: res.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var serverMessage =
            (result.json && (result.json.description || result.json.message)) ||
            "Could not add to cart";
          throw new Error(serverMessage);
        }

        return fetch(Shopify.routes.root + "cart.js")
          .then(function (cartRes) {
            if (!cartRes.ok) throw new Error("Could not refresh cart state");
            return cartRes.json();
          })
          .then(function (cartContent) {
            cartContent.sections = result.json.sections;
            closeDrawer();
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "variant:add",
                  onSuccessDo: "force_open_drawer",
                  cart: cartContent,
                },
              }),
            );
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          });
      })
      .catch(function (error) {
        showQuickAddToast(
          (error && error.message) || "Could not add to cart",
          true,
        );
        console.error("[QuickAdd] Could not add to cart", error);
      })
      .finally(function () {
        btn.classList.remove("is-loading");
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
      });
  }

  function getDrawerStockLabel(status, qty) {
    if (status === "out_of_stock") return "Out of stock";
    if (status === "low_stock") {
      if (!isNaN(qty) && qty > 0 && qty <= 3) return "Only " + qty + " left";
      return "Few left";
    }
    return "In stock";
  }

  function openDrawer(mobileBtn) {
    var card = mobileBtn.closest(".product-card");
    var overlay = card && card.querySelector(".quick-add-overlay");
    drawerTitle.textContent = "Select Size";
    drawerSizes.innerHTML = "";

    if (overlay) {
      overlay.querySelectorAll(".quick-add-size-btn").forEach(function (btn) {
        var clone = btn.cloneNode(true);
        clone.classList.remove("is-loading");

        var sizeLabel = (btn.textContent || "").trim();
        var status = btn.getAttribute("data-inventory-status") || "in_stock";
        var qty = parseInt(btn.getAttribute("data-inventory-qty"), 10);

        clone.textContent = "";

        var sizeSpan = document.createElement("span");
        sizeSpan.className = "quick-add-size-btn__label";
        sizeSpan.textContent = sizeLabel;

        var stockSpan = document.createElement("span");
        stockSpan.className = "quick-add-size-btn__stock";
        stockSpan.textContent = getDrawerStockLabel(status, qty);

        clone.appendChild(sizeSpan);
        clone.appendChild(stockSpan);
        drawerSizes.appendChild(clone);
      });
    }

    drawer.setAttribute("aria-hidden", "false");
    drawer.classList.add("is-open");
    backdrop.classList.add("is-open");
    drawerOpen = true;
    try {
      document.body.style.overflow = "hidden";
    } catch (e) {}
  }

  function closeDrawer() {
    if (!drawerOpen) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    backdrop.classList.remove("is-open");
    drawerOpen = false;
    try {
      document.body.style.overflow = "";
    } catch (e) {}
  }

  document.addEventListener("click", function (e) {
    var sizeBtn = e.target.closest(".product-card__figure .quick-add-size-btn");
    if (sizeBtn) {
      if (sizeBtn.getAttribute("data-inventory-status") === "out_of_stock") {
        e.preventDefault();
        return;
      }
      e.preventDefault();

      addToCart(sizeBtn.dataset.variantId, sizeBtn);
      return;
    }

    var mobileBtn = e.target.closest(".quick-add-mobile-btn");
    if (mobileBtn) {
      e.preventDefault();
      var directId = mobileBtn.getAttribute("data-direct-variant-id");
      if (directId) {
        addToCart(directId, mobileBtn);
      } else {
        openDrawer(mobileBtn);
      }
      return;
    }

    var drawerBtn = e.target.closest(".quick-add-drawer .quick-add-size-btn");
    if (drawerBtn) {
      if (drawerBtn.getAttribute("data-inventory-status") === "out_of_stock") {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      addToCart(drawerBtn.dataset.variantId, drawerBtn);
      return;
    }

    if (e.target.closest(".js-qa-close") || e.target === backdrop) {
      closeDrawer();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawerOpen) closeDrawer();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
  } else {
    setup();
  }
})();

(function () {
  "use strict";

  function setupDescriptionToggle(rootNode) {
    var wrappers = rootNode.querySelectorAll("[data-description-toggle]");

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.descriptionToggleBound === "true") {
        return;
      }

      var content = wrapper.querySelector("[data-description-content]");
      var trigger = wrapper.querySelector("[data-description-trigger]");

      if (!content || !trigger) {
        return;
      }

      var mediaQuery = wrapper.getAttribute("data-description-toggle-media");
      if (mediaQuery && !window.matchMedia(mediaQuery).matches) {
        content.classList.remove("is-collapsed");
        content.style.maxHeight = "none";
        trigger.hidden = true;
        wrapper.dataset.descriptionToggleBound = "true";
        return;
      }

      var lineHeight = parseFloat(window.getComputedStyle(content).lineHeight);
      if (isNaN(lineHeight) || lineHeight <= 0) {
        var fontSize =
          parseFloat(window.getComputedStyle(content).fontSize) || 16;
        lineHeight = fontSize * 1.6;
      }
      var collapsedHeight = lineHeight * 3;

      content.classList.add("is-collapsed");
      content.style.maxHeight = collapsedHeight + "px";
      var isOverflowing = content.scrollHeight > content.clientHeight + 1;

      if (!isOverflowing) {
        content.classList.remove("is-collapsed");
        content.style.maxHeight = "none";
        trigger.hidden = true;
        wrapper.dataset.descriptionToggleBound = "true";
        return;
      }

      trigger.hidden = false;
      trigger.textContent = "Read more";
      trigger.setAttribute("aria-expanded", "false");

      trigger.addEventListener("click", function () {
        var isExpanded = trigger.getAttribute("aria-expanded") === "true";

        if (isExpanded) {
          content.classList.add("is-collapsed");
          content.style.maxHeight = collapsedHeight + "px";
          trigger.textContent = "Read more";
          trigger.setAttribute("aria-expanded", "false");
        } else {
          content.classList.remove("is-collapsed");
          content.style.maxHeight = content.scrollHeight + "px";
          trigger.textContent = "Read less";
          trigger.setAttribute("aria-expanded", "true");
        }
      });

      wrapper.dataset.descriptionToggleBound = "true";
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setupDescriptionToggle(document);
    });
  } else {
    setupDescriptionToggle(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    setupDescriptionToggle(event.target);
  });
  document.addEventListener("shopify:section:reorder", function (event) {
    setupDescriptionToggle(event.target);
  });
  document.addEventListener("shopify:block:select", function (event) {
    setupDescriptionToggle(event.target);
  });
})();

(function () {
  "use strict";

  var countCache = {};
  var abortController = null;
  var debounceTimer = null;
  // Set only by Clear. An ordinary check or uncheck moves the count and nothing else: re-laying out
  // the panel mid-selection reads as the whole drawer jumping, and closing it re-renders the section
  // from the server anyway.
  var pendingGroupSync = false;

  function getDrawer(el) {
    return el.closest("facets-drawer");
  }

  function buildCountUrl(form) {
    var facetsForm = form.closest("facets-form");
    if (!facetsForm) return null;

    var url = new URL(form.getAttribute("action"), window.location.origin);
    var params = new URLSearchParams(new FormData(form));

    ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach(
      function (key) {
        if (params.get(key) === "") params.delete(key);
      },
    );

    url.search = params.toString();
    url.searchParams.set(
      "section_id",
      facetsForm.getAttribute("section-id") || "",
    );
    return url.toString();
  }

  function setCount(drawer, count) {
    drawer.querySelectorAll("[data-facets-count]").forEach(function (el) {
      el.textContent = "(" + count + ")";
    });
  }

  function setBusy(drawer, busy) {
    var applyBtn = drawer.querySelector("[data-facets-apply]");
    var spinner = drawer.querySelector(".facets-footer__spinner");
    if (applyBtn) applyBtn.classList.toggle("is-busy", busy);
    if (spinner) spinner.hidden = !busy;
  }

  function updateGroupCounts(form) {
    form.querySelectorAll("[data-group-count]").forEach(function (span) {
      var details = span.closest("details");
      var content = details && details.querySelector(".accordion__content");
      if (!content) return;

      var count = content.querySelectorAll("input:checked").length;

      // Price is a pair of bounds rather than a list of choices, so it counts once as soon as either
      // end is set — which is what the server renders for the same group.
      var bounds = content.querySelectorAll('input[type="number"]');
      if (bounds.length > 0) {
        count = Array.prototype.some.call(bounds, function (input) {
          return input.value !== "";
        })
          ? 1
          : 0;
      }

      span.textContent = count > 0 ? "(" + count + ")" : "";
    });
  }

  function parseFacetList(html) {
    if (!html) return null;

    var template = document.createElement("template");
    template.innerHTML = html;
    return template.content.firstElementChild;
  }

  function replaceGroupContent(existing, incoming) {
    var target = existing.querySelector(".accordion__content");
    var source = incoming.querySelector(".accordion__content");
    if (!target || !source || target.innerHTML === source.innerHTML) return;

    target.replaceChildren.apply(
      target,
      Array.prototype.slice.call(document.importNode(source, true).childNodes),
    );
  }

  // Clearing wipes every selection, so the narrowed option lists left behind would be wrong in a way
  // no count can explain. The count fetch already returns the freshly rendered facets, so reuse that
  // markup to rebuild the groups. This deliberately does NOT run on an ordinary check or uncheck:
  // relaying out the panel under the shopper mid-selection is more disorienting than a stale list,
  // and closing the drawer re-renders the section anyway. Groups are matched on data-facet-group and
  // their <details> wrapper is kept, so expanded groups stay expanded.
  function syncFacetGroups(form, incomingList) {
    var currentList = form.querySelector(".accordion-list");
    if (!currentList || !incomingList) return;

    var incomingGroups = Array.prototype.slice.call(incomingList.children);
    var keyed = incomingGroups.every(function (group) {
      return group.hasAttribute("data-facet-group");
    });
    if (!keyed) return;

    // The staggered entrance has already played by now, and leaving it armed would re-run it for
    // every group each time one is added or removed and the nth-child delays shift.
    currentList.classList.add("is-live");

    // Clearing puts focus on the Clear button, outside the list, so the guards below are quiet on
    // that path. They are what makes this safe to point at the change handler again — see
    // pendingGroupSync — rather than dead weight.
    var focused =
      document.activeElement && currentList.contains(document.activeElement)
        ? document.activeElement
        : null;

    // A price field fires its change on blur or Enter but keeps focus, so its group is left alone
    // rather than having a half-typed bound replaced under the shopper.
    var frozen =
      focused && focused.matches('input[type="number"], input[type="range"]')
        ? focused.closest("[data-facet-group]")
        : null;

    // IDs shift as value lists grow and shrink, so focus is tracked by what the input submits.
    var focusedName = focused && focused.name ? focused.name : null;
    var focusedValue = focused ? focused.value : null;

    var byKey = {};
    Array.prototype.forEach.call(currentList.children, function (group) {
      var key = group.getAttribute("data-facet-group");
      if (key) byKey[key] = group;
    });

    var next = incomingGroups.map(function (incoming) {
      var existing = byKey[incoming.getAttribute("data-facet-group")];
      if (!existing) return document.importNode(incoming, true);
      if (existing !== frozen) replaceGroupContent(existing, incoming);
      return existing;
    });

    var sameGroups =
      next.length === currentList.children.length &&
      next.every(function (group, index) {
        return currentList.children[index] === group;
      });

    if (!sameGroups) currentList.replaceChildren.apply(currentList, next);

    // Swapping content drops focus, and so does moving a reused group during a restructure. Only
    // reclaim it when nothing else has taken it in the meantime.
    var lost =
      document.activeElement !== focused &&
      (!document.activeElement || document.activeElement === document.body);

    if (focusedName && lost) {
      Array.prototype.some.call(
        currentList.querySelectorAll("input"),
        function (input) {
          if (input.name !== focusedName || input.value !== focusedValue) {
            return false;
          }

          input.focus({ preventScroll: true });
          return true;
        },
      );
    }

    updateGroupCounts(form);
  }

  function refreshCount(form, syncGroups) {
    var drawer = getDrawer(form);
    if (!drawer || !drawer.querySelector("[data-facets-count]")) return;

    var url = buildCountUrl(form);
    if (!url) return;

    if (Object.prototype.hasOwnProperty.call(countCache, url)) {
      setCount(drawer, countCache[url].count);
      if (syncGroups) {
        syncFacetGroups(form, parseFacetList(countCache[url].facets));
      }
      setBusy(drawer, false);
      return;
    }

    if (abortController) abortController.abort();
    abortController = new AbortController();
    setBusy(drawer, true);

    fetch(url, { signal: abortController.signal })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var el = doc.querySelector("[data-products-count]");
        var count = el
          ? parseInt(el.getAttribute("data-products-count"), 10) || 0
          : 0;
        var incomingList = doc.querySelector("facets-drawer .accordion-list");

        countCache[url] = {
          count: count,
          facets: incomingList ? incomingList.outerHTML : "",
        };
        setCount(drawer, count);
        if (syncGroups) syncFacetGroups(form, incomingList);
        setBusy(drawer, false);
      })
      .catch(function (error) {
        if (error.name === "AbortError") return;

        setBusy(drawer, false);
      });
  }

  document.addEventListener("change", function (event) {
    var form = event.target.closest("form.facets");
    if (!form || !getDrawer(form)) return;

    updateGroupCounts(form);

    if (event.target.name === "sort_by") return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var syncGroups = pendingGroupSync;
      pendingGroupSync = false;
      refreshCount(form, syncGroups);
    }, 250);
  });

  document.addEventListener("click", function (event) {
    var clearBtn = event.target.closest("[data-facets-clear]");
    if (!clearBtn) return;

    var drawer = getDrawer(clearBtn);
    var form = drawer && drawer.querySelector("form.facets");
    if (!form) return;

    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.checked = false;
    });
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.value = "";
    });

    pendingGroupSync = true;
    form.dispatchEvent(new Event("change", { bubbles: true }));
  });
})();

(function () {
  "use strict";

  var SHOWN_CLASS = "is-shown-frame";
  var finePointer = window.matchMedia("screen and (pointer: fine)");

  function getFrames(carousel) {
    return Array.prototype.filter.call(carousel.children, function (child) {
      return child.classList.contains("product-card__media");
    });
  }

  function getFrameIndex(carousel) {
    var index = parseInt(carousel.getAttribute("data-frame-index"), 10);
    return isNaN(index) ? 0 : index;
  }

  function showFrame(carousel, index) {
    var frames = getFrames(carousel);
    if (frames.length < 2) return;

    index = Math.max(0, Math.min(index, frames.length - 1));
    if (getFrameIndex(carousel) === index) return;

    carousel.setAttribute("data-frame-index", index);

    frames.forEach(function (frame, position) {
      frame.classList.toggle(SHOWN_CLASS, position > 0 && position <= index);
    });

    // The line indicator listens for this on the carousel it controls.
    carousel.dispatchEvent(
      new CustomEvent("carousel:change", {
        detail: { index: index, cell: frames[index] },
      }),
    );
  }

  function getCarousel(element) {
    var card = element.closest(".product-card");
    return card && card.querySelector(".product-card__media-carousel");
  }

  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-card-nav]");
    if (!btn) return;

    var carousel = getCarousel(btn);
    if (!carousel) return;

    var direction = btn.getAttribute("data-card-nav") === "next" ? 1 : -1;

    if (finePointer.matches) {
      var total = getFrames(carousel).length;
      if (total < 2) return;
      showFrame(
        carousel,
        (getFrameIndex(carousel) + direction + total) % total,
      );
      return;
    }

    var width = carousel.clientWidth;
    var max = carousel.scrollWidth - width;
    var target = Math.round(carousel.scrollLeft + direction * width);

    if (target > max + 5) target = 0;
    if (target < -5) target = max;

    carousel.scrollTo({ left: target, behavior: "smooth" });
  });

  document.addEventListener("mouseover", function (event) {
    if (!finePointer.matches || !event.target.closest) return;

    var card = event.target.closest(".product-card");
    if (!card || (event.relatedTarget && card.contains(event.relatedTarget)))
      return;

    var carousel = card.querySelector(".product-card__media-carousel");
    if (carousel && carousel.hasAttribute("data-hover-frame")) {
      showFrame(
        carousel,
        parseInt(carousel.getAttribute("data-hover-frame"), 10),
      );
    }
  });

  document.addEventListener("mouseout", function (event) {
    if (!finePointer.matches || !event.target.closest) return;

    var card = event.target.closest(".product-card");
    if (!card || (event.relatedTarget && card.contains(event.relatedTarget)))
      return;

    var carousel = card.querySelector(".product-card__media-carousel");
    if (carousel) showFrame(carousel, 0);
  });

  document.addEventListener(
    "carousel:select",
    function (event) {
      var carousel = event.target;
      if (!finePointer.matches || !carousel.classList) return;
      if (!carousel.classList.contains("product-card__media-carousel")) return;

      showFrame(carousel, event.detail.index);
    },
    true,
  );

  if (finePointer.addEventListener) {
    finePointer.addEventListener("change", function () {
      document
        .querySelectorAll(".product-card__media-carousel[data-frame-index]")
        .forEach(function (carousel) {
          showFrame(carousel, 0);
          carousel.scrollTo({ left: 0, behavior: "auto" });
        });
    });
  }
})();

(function () {
  "use strict";

  var SEED = (Math.random() * 4294967296) >>> 0;

  var FIRST_GAP_MIN = 7;
  var FIRST_GAP_MAX = 10;
  var GAP_MIN = 12;
  var GAP_MAX = 17;
  var REF_COLS = 4;
  var MIN_GAP = 8;

  var PROMO_SIZES = [
    { cols: 1, rows: 1, weight: 26 },
    { cols: 2, rows: 1, weight: 20 },
    { cols: 1, rows: 2, weight: 12 },
    { cols: 2, rows: 2, weight: 14 },
    { cols: 3, rows: 1, weight: 9 },
    { cols: 4, rows: 1, weight: 7 },
    { cols: 3, rows: 2, weight: 7 },
    { cols: 4, rows: 2, weight: 5 },
  ];
  var TOTAL_WEIGHT = PROMO_SIZES.reduce(function (sum, s) {
    return sum + s.weight;
  }, 0);

  function mulberry32(a) {
    return function () {
      a |= 0;
      a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function randInt(rand, min, max) {
    return min + Math.floor(rand() * (max - min + 1));
  }

  function shuffle(arr, rand) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(rand() * (i + 1));
      var t = arr[i];
      arr[i] = arr[j];
      arr[j] = t;
    }
    return arr;
  }

  function isProductCard(node) {
    return node.nodeType === 1 && node.tagName === "PRODUCT-CARD";
  }

  function pickSize(rand) {
    var r = rand() * TOTAL_WEIGHT;
    for (var i = 0; i < PROMO_SIZES.length; i++) {
      r -= PROMO_SIZES[i].weight;
      if (r < 0) return PROMO_SIZES[i];
    }
    return PROMO_SIZES[0];
  }

  function parseSource(node) {
    var d = node.dataset;
    return {
      node: node,
      cols: d.cols ? parseInt(d.cols, 10) : null,
      rows: d.rows ? parseInt(d.rows, 10) : null,
      placement:
        d.placement === "left" || d.placement === "right" ? d.placement : null,
      position: d.position ? parseInt(d.position, 10) : null,
      order: d.order ? parseInt(d.order, 10) : null,
    };
  }

  function orderFlowing(base, rand, firstPass) {
    if (!firstPass) return shuffle(base.slice(), rand);
    var ordered = base
      .filter(function (p) {
        return p.order != null;
      })
      .sort(function (a, b) {
        return a.order - b.order;
      });
    var rest = shuffle(
      base.filter(function (p) {
        return p.order == null;
      }),
      rand,
    );
    return ordered.concat(rest);
  }

  function nextFlowing(state) {
    if (!state.baseFlowing.length) return null;
    if (state.flowIdx >= state.flowing.length) {
      state.flowing = orderFlowing(state.baseFlowing, state.rand, false);
      state.flowIdx = 0;
    }
    return state.flowing[state.flowIdx++];
  }

  function sizeFor(src, rand) {
    if (src.cols != null || src.rows != null) {
      return { cols: src.cols || 1, rows: src.rows || 1 };
    }
    return pickSize(rand);
  }

  function gapFor(state, size) {
    return (
      randInt(state.rand, GAP_MIN, GAP_MAX) +
      (size.rows - 1) * REF_COLS +
      (size.cols - 1)
    );
  }

  function buildPromo(state, src, size) {
    var clone = src.node.cloneNode(true);
    clone.style.setProperty(
      "--product-list-promo-column-span",
      String(size.cols),
    );
    if (size.rows === 2) {
      clone.classList.add("product-list__promo--rows-2");
    }
    if (size.cols >= 2) {
      clone.classList.add("product-list__promo--mobile-bleed");
    }
    if (size.cols >= 2 || size.rows >= 2) {
      var side;
      if (src.placement) {
        side = src.placement;
      } else {
        state.snapSide = state.snapSide === "left" ? "right" : "left";
        side = state.snapSide;
      }
      clone.classList.add("product-list__promo--snap-" + side);
    }
    return clone;
  }

  function process(productList, state) {
    var cards = productList.querySelectorAll(":scope > product-card");
    var count = cards.length;

    while (true) {
      var pinPos =
        state.pinnedIdx < state.pinned.length
          ? state.pinned[state.pinnedIdx].position
          : Infinity;
      var usePin = pinPos <= state.nextAt;
      var pos = usePin ? pinPos : state.nextAt;
      if (pos > count) break;

      if (!usePin && state.lastAt > 0 && pos - state.lastAt < MIN_GAP) {
        state.nextAt = state.lastAt + MIN_GAP;
        continue;
      }

      var src = usePin ? state.pinned[state.pinnedIdx++] : nextFlowing(state);
      if (!src) break;
      var size = sizeFor(src, state.rand);

      productList.insertBefore(buildPromo(state, src, size), cards[pos - 1]);
      state.lastAt = pos;

      if (usePin) {
        if (state.nextAt <= pos + MIN_GAP)
          state.nextAt = pos + gapFor(state, size);
      } else {
        state.nextAt = pos + gapFor(state, size);
      }
    }
  }

  var listObserver = null;
  var currentProductList = null;

  function updateRowUnit(productList) {
    var media = productList.querySelector("product-card .product-card__media");
    if (!media) return;
    var height = media.getBoundingClientRect().height;
    if (height > 0) {
      productList.style.setProperty("--promo-row-unit", height + "px");
    }
  }

  function setup(section) {
    if (listObserver) {
      listObserver.disconnect();
      listObserver = null;
    }

    var productList = section.querySelector("product-list.product-list");
    var template = section.querySelector("#collection-promos-template");
    if (!productList || !template) return;

    var sourceNodes = Array.prototype.slice.call(template.content.children);
    if (!sourceNodes.length) return;

    var parsed = sourceNodes.map(parseSource);
    var pinned = parsed
      .filter(function (p) {
        return p.position != null;
      })
      .sort(function (a, b) {
        return a.position - b.position;
      });
    var baseFlowing = parsed.filter(function (p) {
      return p.position == null;
    });

    var rand = mulberry32(SEED);
    var state = {
      baseFlowing: baseFlowing,
      flowing: orderFlowing(baseFlowing, rand, true),
      flowIdx: 0,
      pinned: pinned,
      pinnedIdx: 0,
      rand: rand,
      nextAt: randInt(rand, FIRST_GAP_MIN, FIRST_GAP_MAX),
      lastAt: 0,
      snapSide: rand() < 0.5 ? "left" : "right",
    };

    currentProductList = productList;
    updateRowUnit(productList);
    process(productList, state);

    listObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (isProductCard(added[j])) {
            process(productList, state);
            return;
          }
        }
      }
    });
    listObserver.observe(productList, { childList: true });
  }

  function init() {
    var section = document.querySelector(".shopify-section--main-collection");
    if (!section) return;

    setup(section);

    new MutationObserver(function () {
      setup(section);
    }).observe(section, { childList: true });

    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (currentProductList && currentProductList.isConnected) {
          updateRowUnit(currentProductList);
        }
      }, 200);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------------------------------
   COLLECTION GROUP NAV
   Swaps the product grid in place when a sub-collection link is clicked, instead of reloading the
   whole page. The nav is rendered inside the main collection section, so the section render Shopify
   returns already contains the updated links, active state and count — nothing has to be synced by
   hand here, we just swap the section's markup and push the URL.
   -------------------------------------------------------------------------------------------------- */
(function () {
  var SECTION_SELECTOR = ".shopify-section--main-collection";
  var CHIP_SELECTOR = ".collection-group-nav__chip";
  var inFlight = null;
  var hasSwapped = false;

  function sectionIdFrom(element) {
    // Section wrappers are id="shopify-section-<sectionId>"; the id is what ?section_id= expects.
    var id = element.id || "";
    return id.indexOf("shopify-section-") === 0 ? id.slice("shopify-section-".length) : null;
  }

  function swap(section, url) {
    var sectionId = sectionIdFrom(section);
    if (!sectionId) return false;

    var requestUrl = new URL(url, window.location.origin);
    requestUrl.searchParams.set("section_id", sectionId);

    var nav = section.querySelector(".collection-group-nav");
    if (nav) nav.classList.add("is-loading");

    if (inFlight) inFlight.abort();
    inFlight = new AbortController();

    fetch(requestUrl.toString(), { signal: inFlight.signal })
      .then(function (response) {
        if (!response.ok) throw new Error("Section render failed: " + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, "text/html");
        // Shopify may return the section with or without its own wrapper, so accept either shape.
        var fresh = parsed.getElementById(section.id);
        section.innerHTML = fresh ? fresh.innerHTML : parsed.body.innerHTML;

        if (url !== window.location.href) {
          window.history.pushState({ collectionGroupNav: true }, "", url);
        }
        hasSwapped = true;
      })
      .catch(function (error) {
        if (error.name === "AbortError") return;
        // Never strand the shopper on a stale grid — fall back to the navigation we intercepted.
        window.location.href = url;
      })
      .finally(function () {
        inFlight = null;
        var currentNav = section.querySelector(".collection-group-nav");
        if (currentNav) currentNav.classList.remove("is-loading");
      });

    return true;
  }

  document.addEventListener("click", function (event) {
    // Let modified clicks (new tab, download, middle click) behave as the browser intends.
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.button !== 0) return;

    var link = event.target.closest ? event.target.closest(CHIP_SELECTOR) : null;
    if (!link || !link.href) return;

    var section = link.closest(SECTION_SELECTOR);
    if (!section) return;

    if (swap(section, link.href)) event.preventDefault();
  });

  // A back/forward step between groups has to re-fetch, since the grid was swapped in, not loaded.
  // The entry the shopper first landed on carries no state of ours, so once we have swapped even
  // once we own every popstate on this page — otherwise going back to that first entry would move
  // the URL but leave the previous group's products on screen.
  window.addEventListener("popstate", function () {
    if (!hasSwapped) return;
    var section = document.querySelector(SECTION_SELECTOR);
    if (section) swap(section, window.location.href);
  });
})();
